import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
var Breadcrumb = function (props) {
    var _a = props.separator, separator = _a === void 0 ? '/' : _a, customisedCls = props.prefixCls, className = props.className, style = props.style, children = props.children;
    var configContext = useContext(ConfigContext);
    var prefixCls = getPrefixCls('breadcrumb', configContext.prefixCls, customisedCls);
    var cls = classNames(prefixCls, className);
    return (React.createElement("nav", { className: cls, style: style },
        React.createElement("ol", { className: prefixCls + "__ol" }, React.Children.map(children, function (child) {
            var childProps = { separator: separator };
            return React.cloneElement(child, childProps);
        }))));
};
Breadcrumb.displayName = 'Breadcrumb';
export default Breadcrumb;
//# sourceMappingURL=breadcrumb.js.map